<label for="map-options">Options</label>
<div class="map-options" id="map-options">
  <div class="traffic-options">
    @for (option of optionData; track trackByFn($index)) {
        <label class="checkbox">
          <input type="checkbox"
            name="options"
            [(ngModel)]="option.value"
            (change)="updateCheckedOptions(option,  $event)"/>
            <span class="tick"></span>
            <span class="label no-strong">{{option.name}}</span>
            <img [src]="option.imageLogoPath" [alt]="option.name" class="icon"/>
        </label>
      }
    </div>
  </div>

  <div class="route-config">
    <button type="button" class="link-btn copy-button" (click)="copyText()">
      <span>Link</span>
    </button>
    <div class="tooltipShow">Copied to clipboard</div>
  </div>
